module.exports = ".license-checkbox {\n  margin-left: 15px; }\n\nfieldset {\n  padding-top: 0; }\n\n.alert-with-padding {\n  margin-top: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/external-user-modal-form/external-user-modal-form.component.scss
// module id = ./src/app/+app-custom/components/external-user-modal-form/external-user-modal-form.component.scss
// module chunks = main